import React from 'react'
import Header from '../layouts/Header'
import Footer from '../layouts/Footer'
import ProcessSection from '../layouts/Home/ProcessSection'
import TechnologiesSection from '../layouts/Home/TechnologiesSection'
import PortfolioSection from '../layouts/Home/PortfolioSection'
import TestimonialsSection from '../layouts/Home/TestimonialsSection'
import CtaSection from '../layouts/Home/CtaSection'
import FinalCTA from '../layouts/FinalCTA'
import { NavLink } from 'react-router-dom'
import {
    FaMobileAlt,
    FaRocket,
    FaPaintBrush,
} from "react-icons/fa";

import {
    SiFlutter,
} from "react-icons/si";

import {
    FaApple,
    FaAndroid,

} from "react-icons/fa";

import { TbBrandReactNative } from "react-icons/tb";


const Home = () => {
    return (
        <>
            <Header />
            <div
                style={{
                    background:
                        "linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)",
                    padding: "56px 24px 52px",
                    position: "relative",
                    overflow: "hidden",

                    animation: "fadeIn .6s .3s both",

                }}
            >
                {/* Subtle grid lines */}
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        pointerEvents: "none",
                        opacity: 0.35,
                    }}
                >
                    <svg width="100%" height="100%">
                        <defs>
                            <pattern
                                id="lines"
                                x="0"
                                y="0"
                                width="60"
                                height="60"
                                patternUnits="userSpaceOnUse"
                            >
                                <path
                                    d="M60 0L0 0L0 60"
                                    fill="none"
                                    stroke="#E8212A"
                                    strokeWidth=".4"
                                    opacity=".3"
                                />
                            </pattern>
                        </defs>

                        <rect width="100%" height="100%" fill="url(#lines)" />
                    </svg>
                </div>

                {/* Big red blob */}
                <div
                    style={{
                        position: "absolute",
                        right: "-120px",
                        top: "-80px",
                        width: "500px",
                        height: "500px",
                        background:
                            "radial-gradient(circle,rgba(232,33,42,.05) 0%,transparent 68%)",
                        pointerEvents: "none",
                    }}
                />

                <div
                    style={{
                        maxWidth: "1440px",
                        margin: "0 auto",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        gap: "40px",
                        position: "relative",
                        zIndex: 1,
                        flexWrap: "wrap",
                    }}
                >
                    {/* Left content */}
                    <div style={{ flex: 1, minWidth: "320px" }}>
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                                background: "#fff",
                                border: "1.5px solid #f0e8e8",
                                borderRadius: "100px",
                                padding: "5px 14px",
                                marginBottom: "20px",
                                boxShadow: "0 2px 10px rgba(232,33,42,.08)",
                                animation: "fadeSlideDown .6s .4s both",
                                width: "fit-content"
                            }}
                        >
                            <span
                                style={{
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    background: "#E8212A",
                                    display: "inline-block",
                                    animation: "pulse 2s infinite",
                                }}
                            />

                            <span
                                style={{
                                    fontFamily: "'Plus Jakarta Sans',sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    color: "#E8212A",
                                    letterSpacing: ".3px",
                                    textAlign: "start",
                                }}
                            >
                                App Development Studio
                            </span>
                        </div>

                        <h1
                            style={{
                                fontFamily: "'Syne',sans-serif",
                                fontSize: "clamp(34px,4.5vw,58px)",
                                fontWeight: 800,
                                color: "#111",
                                lineHeight: 1.08,
                                margin: "0 0 6px",
                                letterSpacing: "-1.5px",
                                animation: "fadeSlideDown .65s .5s both",
                                textAlign: "start"
                            }}
                        >
                            We Build Apps
                            <br />
                            <span style={{ color: "#E8212A" }}>People Can't</span>
                            <br />
                            <span style={{ color: "#111" }}>Put Down.</span>
                        </h1>

                        <p
                            style={{
                                fontFamily: "'Plus Jakarta Sans',sans-serif",
                                fontSize: "15.5px",
                                color: "#666",
                                lineHeight: 1.75,
                                margin: "18px 0 32px",
                                maxWidth: "430px",
                                textAlign: "start",
                                animation: "fadeSlideUp .65s .6s both",
                            }}
                        >
                            iOS, Android & cross-platform apps engineered for
                            performance, designed for delight — from MVP to millions of
                            users.
                        </p>

                        {/* CTAs */}
                        <div
                            style={{
                                display: "flex",
                                gap: "12px",
                                flexWrap: "wrap",
                                marginBottom: "40px",
                                animation: "fadeSlideUp .65s .7s both",
                            }}
                        >
                            <NavLink to="/Contactus">
                                <a
                                    href="#"
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontWeight: 700,
                                        fontSize: "14px",
                                        color: "#fff",
                                        background: "#E8212A",
                                        padding: "13px 26px",
                                        borderRadius: "10px",
                                        textDecoration: "none",
                                        boxShadow: "0 4px 20px rgba(232,33,42,.38)",
                                        transition: "all .2s",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "7px",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.transform = "translateY(-2px)";
                                        e.currentTarget.style.boxShadow =
                                            "0 8px 28px rgba(232,33,42,.45)";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.transform = "";
                                        e.currentTarget.style.boxShadow =
                                            "0 4px 20px rgba(232,33,42,.38)";
                                    }}
                                >
                                    <svg
                                        width="16"
                                        height="16"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                    >
                                        <path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z" />
                                    </svg>

                                    Start Your App
                                </a>
                            </NavLink>
                            <NavLink to="/CaseStudies">
                                <a
                                    href="#"
                                    style={{
                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        fontWeight: 600,
                                        fontSize: "14px",
                                        color: "#1a1a1a",
                                        background: "#fff",
                                        padding: "13px 26px",
                                        borderRadius: "10px",
                                        textDecoration: "none",
                                        border: "1.5px solid #e8e8e8",
                                        transition: "all .2s",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        gap: "7px",
                                    }}
                                    onMouseEnter={(e) => {
                                        e.currentTarget.style.borderColor = "#E8212A";
                                        e.currentTarget.style.color = "#E8212A";
                                    }}
                                    onMouseLeave={(e) => {
                                        e.currentTarget.style.borderColor = "#e8e8e8";
                                        e.currentTarget.style.color = "#1a1a1a";
                                    }}
                                >
                                    <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                    >
                                        <polygon points="5 3 19 12 5 21 5 3" />
                                    </svg>

                                    View Case Studies
                                </a>
                            </NavLink>
                        </div>

                        {/* Platform tags */}
                        <div
                            style={{
                                display: "flex",
                                gap: "8px",
                                flexWrap: "wrap",
                                animation: "fadeSlideUp .65s .85s both",
                            }}
                        >
                            <NavLink to="/Technologie/Swift">
                                <div
                                    className="tag"
                                    style={{
                                        background: "#f0f7ff",
                                        color: "#0C447C",
                                        border: "1px solid #b5d4f4",
                                    }}
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                    >
                                        <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z" />
                                    </svg>

                                    iOS (Swift)
                                </div>
                            </NavLink>
                            <NavLink to="/Technologie/Kotlin">
                                <div
                                    className="tag"
                                    style={{
                                        background: "#f0fff4",
                                        color: "#27500A",
                                        border: "1px solid #c0dd97",
                                    }}
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 24 24"
                                        fill="currentColor"
                                    >
                                        <path d="M17.6 9.48l1.84-3.18c.16-.31.04-.69-.26-.85-.29-.15-.65-.06-.83.22l-1.88 3.24c-1.43-.64-3.03-1-4.77-1s-3.34.36-4.77 1L4.85 5.67c-.19-.29-.55-.37-.83-.22-.31.16-.42.54-.26.85L5.6 9.48C3.3 10.78 1.7 13.04 1.7 15.6h20.6c0-2.56-1.6-4.82-3.9-6.12zM7.8 13.8c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm8.4 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z" />
                                    </svg>

                                    Android (Kotlin)
                                </div>
                            </NavLink>
                            <NavLink to="/Technologie/ReactNative">
                                <div
                                    className="tag"
                                    style={{
                                        background: "#fdf0ff",
                                        color: "#3C3489",
                                        border: "1px solid #cecbf6",
                                    }}
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                    >
                                        <rect x="5" y="2" width="14" height="20" rx="2" />
                                        <line x1="12" y1="18" x2="12" y2="18" />
                                    </svg>

                                    React Native
                                </div>
                            </NavLink>
                            <NavLink to="/Technologie/flutter">
                                <div
                                    className="tag"
                                    style={{
                                        background: "#fff5f0",
                                        color: "#712B13",
                                        border: "1px solid #f0997b",
                                    }}
                                >
                                    <svg
                                        width="12"
                                        height="12"
                                        viewBox="0 0 24 24"
                                        fill="none"
                                        stroke="currentColor"
                                        strokeWidth="2.5"
                                    >
                                        <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5" />
                                    </svg>

                                    Flutter
                                </div>
                            </NavLink>
                        </div>
                    </div>
                    <div
                        style={{
                            position: "relative",
                            width: "100%",
                            maxWidth: "420px",
                            height: "540px",
                            margin: "0 auto",
                            flexShrink: 0,
                            animation: "floatingCard 5s ease-in-out infinite"
                        }}
                    >
                        {/* Glow Background */}
                        <div
                            style={{
                                position: "absolute",
                                width: "320px",
                                height: "320px",
                                background:
                                    "radial-gradient(circle, rgba(232,33,42,0.18) 0%, rgba(232,33,42,0) 70%)",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%,-50%)",
                                filter: "blur(20px)",
                                animation: "pulseGlow 4s ease-in-out infinite",
                            }}
                        />

                        {/* Floating Card */}
                        <div
                            style={{
                                position: "absolute",
                                top: "40px",
                                left: "-10px",
                                background: "#fff",
                                border: "1px solid #f2dada",
                                borderRadius: "18px",
                                padding: "14px",
                                width: "140px",
                                zIndex: 5,
                                boxShadow: "0 20px 50px rgba(232,33,42,.12)",
                                animation: "floatCard 5s ease-in-out infinite",
                            }}
                        >
                            <div
                                style={{
                                    fontSize: "11px",
                                    color: "#999",
                                    fontFamily: "'Plus Jakarta Sans',sans-serif",
                                    marginBottom: "8px",
                                }}
                            >
                                APP STORE RATING
                            </div>

                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "8px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "14px",
                                        background: "linear-gradient(135deg,#E8212A,#ff6269)",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#fff",
                                        fontWeight: "700",
                                        fontSize: "18px",
                                    }}
                                >
                                    ★
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontSize: "20px",
                                            fontWeight: "800",
                                            color: "#111",
                                            fontFamily: "'Syne',sans-serif",
                                        }}
                                    >
                                        4.9
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "10px",
                                            color: "#888",
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        }}
                                    >
                                        12K Reviews
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* MAIN PHONE */}
                        <div
                            style={{
                                position: "absolute",
                                left: "50%",
                                transform: "translateX(-50%)",
                                width: "290px",
                                height: "580px",
                                background: "#111",
                                borderRadius: "42px",
                                padding: "10px",
                                border: "3px solid #2a2a2a",
                                boxShadow:
                                    "0 30px 80px rgba(232,33,42,.20),0 10px 30px rgba(0,0,0,.18)",
                                animation: "floatPhoneMain 6s ease-in-out infinite",
                                overflow: "hidden",
                            }}
                        >
                            {/* Screen */}
                            <div
                                style={{
                                    width: "100%",
                                    height: "100%",
                                    borderRadius: "34px",
                                    background: "#fff",
                                    overflow: "hidden",
                                    position: "relative",
                                }}
                            >
                                {/* Dynamic Island */}
                                <div
                                    style={{
                                        position: "absolute",
                                        top: "12px",
                                        left: "50%",
                                        transform: "translateX(-50%)",
                                        width: "90px",
                                        height: "26px",
                                        borderRadius: "20px",
                                        background: "#111",
                                        zIndex: 5,
                                    }}
                                />

                                {/* Header */}
                                <div
                                    style={{
                                        background: "linear-gradient(135deg,#E8212A,#ff5b63)",
                                        padding: "48px 22px 18px",
                                        color: "#fff",
                                        position: "relative",
                                    }}
                                >
                                    <div
                                        style={{
                                            fontSize: "13px",
                                            opacity: 0.8,
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        }}
                                    >
                                        APPVERSELABS
                                    </div>

                                    <h3
                                        style={{
                                            fontSize: "15px",
                                            lineHeight: 1.05,
                                            marginTop: "8px",
                                            fontWeight: "800",
                                            fontFamily: "'Syne',sans-serif",
                                        }}
                                    >
                                        Mobile Apps
                                        <br />
                                        That Users Love.
                                    </h3>

                                    {/* Floating Mini Circle */}
                                    <div
                                        style={{
                                            position: "absolute",
                                            right: "-20px",
                                            top: "20px",
                                            width: "90px",
                                            height: "90px",
                                            borderRadius: "50%",
                                            background: "rgba(255,255,255,.12)",
                                            backdropFilter: "blur(8px)",
                                        }}
                                    />
                                </div>

                                {/* App Cards */}
                                <div
                                    style={{
                                        padding: "18px",
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "14px",
                                    }}
                                >
                                    {/* Card */}
                                    <div
                                        style={{
                                            background: "#fff5f5",
                                            borderRadius: "18px",
                                            padding: "14px",
                                            border: "1px solid #ffe2e2",
                                            animation: "fadeSlideUp .6s .7s both",
                                        }}
                                    >
                                        <div
                                            style={{
                                                display: "flex",
                                                alignItems: "center",
                                                justifyContent: "space-between",
                                                marginBottom: "10px",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    gap: "10px",
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        width: "42px",
                                                        height: "42px",
                                                        borderRadius: "14px",
                                                        background: "#E8212A",
                                                        display: "flex",
                                                        alignItems: "center",
                                                        justifyContent: "center",
                                                        fontSize: "20px",
                                                    }}
                                                >
                                                    📱
                                                </div>

                                                <div>
                                                    <div
                                                        style={{
                                                            fontSize: "15px",
                                                            fontWeight: "700",
                                                            color: "#111",
                                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                                        }}
                                                    >
                                                        Food Delivery App
                                                    </div>

                                                    <div
                                                        style={{
                                                            fontSize: "11px",
                                                            color: "#888",
                                                            marginTop: "2px",
                                                        }}
                                                    >
                                                        UI/UX + Development
                                                    </div>
                                                </div>
                                            </div>

                                            <span
                                                style={{
                                                    background: "#fff",
                                                    color: "#E8212A",
                                                    fontSize: "11px",
                                                    padding: "6px 10px",
                                                    borderRadius: "30px",
                                                    fontWeight: "700",
                                                }}
                                            >
                                                Live
                                            </span>
                                        </div>

                                        {/* Progress */}
                                        <div
                                            style={{
                                                height: "8px",
                                                borderRadius: "20px",
                                                background: "#ffd7d7",
                                                overflow: "hidden",
                                            }}
                                        >
                                            <div
                                                style={{
                                                    width: "88%",
                                                    height: "100%",
                                                    borderRadius: "20px",
                                                    background:
                                                        "linear-gradient(90deg,#E8212A,#ff7c82)",
                                                    animation: "progressAnim 3s ease infinite",
                                                }}
                                            />
                                        </div>
                                    </div>

                                    {/* Stats */}
                                    <div
                                        style={{
                                            display: "grid",
                                            gridTemplateColumns: "1fr 1fr",
                                            gap: "12px",
                                        }}
                                    >
                                        {[
                                            ["150+", "Apps Built"],
                                            ["10M+", "Downloads"],
                                            ["98%", "Client Rate"],
                                            ["24/7", "Support"],
                                        ].map((item, index) => (
                                            <div
                                                key={index}
                                                style={{
                                                    background: "#fff",
                                                    border: "1px solid #f1f1f1",
                                                    borderRadius: "18px",
                                                    padding: "16px",
                                                    textAlign: "center",
                                                    boxShadow: "0 10px 30px rgba(0,0,0,.04)",
                                                    animation: `fadeSlideUp .6s ${0.8 + index * 0.1}s both`,
                                                }}
                                            >
                                                <div
                                                    style={{
                                                        fontSize: "22px",
                                                        fontWeight: "800",
                                                        color: "#E8212A",
                                                        fontFamily: "'Syne',sans-serif",
                                                    }}
                                                >
                                                    {item[0]}
                                                </div>

                                                <div
                                                    style={{
                                                        fontSize: "11px",
                                                        color: "#888",
                                                        marginTop: "4px",
                                                        fontFamily: "'Plus Jakarta Sans',sans-serif",
                                                    }}
                                                >
                                                    {item[1]}
                                                </div>
                                            </div>
                                        ))}
                                    </div>

                                    {/* Bottom CTA */}
                                    <div
                                        style={{
                                            marginTop: "8px",
                                            background: "#111",
                                            borderRadius: "18px",
                                            padding: "16px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            animation: "fadeSlideUp .7s 1.2s both",
                                        }}
                                    >
                                        <div>
                                            <div
                                                style={{
                                                    fontSize: "14px",
                                                    color: "#fff",
                                                    fontWeight: "700",
                                                    fontFamily: "'Plus Jakarta Sans',sans-serif",
                                                }}
                                            >
                                                Start Your Project
                                            </div>

                                            <div
                                                style={{
                                                    fontSize: "11px",
                                                    color: "#777",
                                                    marginTop: "2px",
                                                }}
                                            >
                                                Build your next big app
                                            </div>
                                        </div>

                                        <NavLink to="/contactus">
                                            <div
                                                style={{
                                                    width: "42px",
                                                    height: "42px",
                                                    borderRadius: "14px",
                                                    background: "#E8212A",
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                    color: "#fff",
                                                    fontSize: "18px",
                                                    fontWeight: "700",
                                                    cursor: "pointer",
                                                    textDecoration: "none",
                                                }}
                                            >
                                                →
                                            </div>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Floating Download Badge */}
                        {/* <div
                            style={{
                                position: "absolute",
                                right: "-5px",
                                bottom: "70px",
                                background: "#111",
                                borderRadius: "18px",
                                padding: "14px 16px",
                                boxShadow: "0 20px 40px rgba(0,0,0,.18)",
                                animation: "floatBadge 4s ease-in-out infinite",
                            }}
                        >
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                }}
                            >
                                <div
                                    style={{
                                        width: "42px",
                                        height: "42px",
                                        borderRadius: "14px",
                                        background: "#E8212A",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        color: "#fff",
                                        fontSize: "18px",
                                    }}
                                >
                                    🚀
                                </div>

                                <div>
                                    <div
                                        style={{
                                            fontSize: "18px",
                                            color: "#fff",
                                            fontWeight: "800",
                                            fontFamily: "'Syne',sans-serif",
                                        }}
                                    >
                                        2M+
                                    </div>

                                    <div
                                        style={{
                                            fontSize: "10px",
                                            color: "#888",
                                            fontFamily: "'Plus Jakarta Sans',sans-serif",
                                        }}
                                    >
                                        App Downloads
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                </div>
            </div>
            {/* Stats bar */}
            <div
                style={{
                    background: "#fff",
                    borderTop: "1px solid #f0f0f0",
                    borderBottom: "1px solid #f0f0f0",
                    padding: "20px 16px",
                    animation: "fadeIn .7s .9s both",
                }}
            >
                <div className="stats-grid">
                    <div className="stats-card stats-border">
                        <span className="stats-number">
                            150+
                        </span>

                        <span className="stats-text">
                            Apps Shipped
                        </span>
                    </div>

                    <div className="stats-card stats-border">
                        <span className="stats-number">
                            10M+
                        </span>

                        <span className="stats-text">
                            Total Downloads
                        </span>
                    </div>

                    <div className="stats-card stats-border mobile-remove-border">
                        <span className="stats-number">
                            4.8★
                        </span>

                        <span className="stats-text">
                            Avg App Rating
                        </span>
                    </div>

                    <div className="stats-card">
                        <span className="stats-number">
                            8 yrs
                        </span>

                        <span className="stats-text">
                            In Business
                        </span>
                    </div>
                </div>

                <style>{`

        .stats-grid{
            max-width:1440px;
            margin:0 auto;
            display:grid;
            grid-template-columns:repeat(4,1fr);
            align-items:center;
        }

        .stats-card{
            display:flex;
            flex-direction:column;
            align-items:center;
            justify-content:center;
            padding:14px 20px;
            text-align:center;
        }

        .stats-border{
            border-right:1px solid #f0f0f0;
        }

        .stats-number{
            font-family:'Syne',sans-serif;
            font-weight:800;
            font-size:clamp(22px,3vw,26px);
            color:#E8212A;
            letter-spacing:-1px;
        }

        .stats-text{
            font-family:'Plus Jakarta Sans',sans-serif;
            font-size:12px;
            color:#999;
            margin-top:4px;
            line-height:1.5;
        }

        @media(max-width:992px){

            .stats-grid{
                grid-template-columns:repeat(2,1fr);
            }

            .stats-card{
                padding:22px 16px;
            }

            .stats-border{
                border-right:none;
            }

            .stats-card:nth-child(1),
            .stats-card:nth-child(2){
                border-bottom:1px solid #f0f0f0;
            }

            .stats-card:nth-child(1),
            .stats-card:nth-child(3){
                border-right:1px solid #f0f0f0;
            }

        }

        @media(max-width:576px){

            .stats-grid{
                grid-template-columns:1fr 1fr;
            }

            .stats-card{
                padding:18px 10px;
            }

            .stats-number{
                font-size:22px;
            }

            .stats-text{
                font-size:11px;
            }

        }

    `}</style>
            </div>
            {/* ===== WHY CHOOSE US SECTION ===== */}

            <section
                className="why-section"
                style={{
                    background:
                        "linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)",
                    padding: "56px 24px 52px",
                    position: "relative",
                    overflow: "hidden",
                    animation: "fadeIn .6s .3s both",
                }}
            >
                <div className="why-container">

                    {/* Left Side */}
                    <div className="why-left">
                        <div
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "7px",
                                background: "#fff",
                                border: "1.5px solid #f0e8e8",
                                borderRadius: "100px",
                                padding: "5px 14px",
                                marginBottom: "20px",
                                boxShadow: "0 2px 10px rgba(232,33,42,.08)",
                                animation: "fadeSlideDown .6s .4s both",
                                width: "fit-content"
                            }}
                        >
                            <span
                                style={{
                                    width: "6px",
                                    height: "6px",
                                    borderRadius: "50%",
                                    background: "#E8212A",
                                    display: "inline-block",
                                    animation: "pulse 2s infinite",
                                }}
                            />

                            <span
                                style={{
                                    fontFamily: "'Plus Jakarta Sans',sans-serif",
                                    fontSize: "12px",
                                    fontWeight: 600,
                                    color: "#E8212A",
                                    letterSpacing: ".3px",
                                    textAlign: "start",
                                }}
                            >
                                Why AppVerse Labs
                            </span>
                        </div>
                        <h2>
                            We Build High-Performance
                            <span> Mobile Applications.</span>
                        </h2>

                        <p>
                            AppVerseLabs specializes in crafting scalable,
                            secure and user-focused mobile applications
                            for startups, businesses and enterprises.
                            From idea validation to App Store launch,
                            we handle the complete app development lifecycle.
                        </p>

                        <div className="why-grid">

                            <div className="why-card">
                                <div className="why-icon">
                                    <FaMobileAlt />
                                </div>

                                <h4>Native App Development</h4>

                                <p>
                                    Powerful iOS & Android applications built
                                    using Swift and Kotlin for maximum performance.
                                </p>
                            </div>

                            <div className="why-card">
                                <div className="why-icon">
                                    <SiFlutter />
                                </div>

                                <h4>Cross-Platform Apps</h4>

                                <p>
                                    Build apps faster with React Native & Flutter
                                    while maintaining native-like experience.
                                </p>
                            </div>

                            <div className="why-card">
                                <div className="why-icon">
                                    <FaPaintBrush />
                                </div>

                                <h4>App UI/UX Design</h4>

                                <p>
                                    Modern mobile-first interfaces designed
                                    to improve engagement and retention.
                                </p>
                            </div>

                            <div className="why-card">
                                <div className="why-icon">
                                    <FaRocket />
                                </div>

                                <h4>Launch & Scaling</h4>

                                <p>
                                    App Store deployment, analytics integration,
                                    maintenance and long-term growth support.
                                </p>
                            </div>
                        </div>
                    </div>
                    <style>{`.why-icon{
    width:70px;
    height:70px;
    display:flex;
    align-items:center;
    justify-content:center;
    border-radius:20px;
    background:linear-gradient(
        135deg,
        #E8212A,
        #ff646b
    );
    color:#fff;
    font-size:30px;
    margin-bottom:20px;
    box-shadow:0 15px 35px rgba(232,33,42,.25);
    transition:.3s ease;
}

.why-card:hover .why-icon{
    transform:translateY(-6px) rotate(-5deg);
}
.service-icon{
    width:64px;
    height:64px;
    border-radius:18px;
    display:flex;
    align-items:center;
    justify-content:center;
    font-size:28px;
    color:#fff;

    background:linear-gradient(
        135deg,
        #E8212A,
        #ff6269
    );

    box-shadow:
        0 15px 35px rgba(232,33,42,.25);

    transition:.4s ease;
}

.service-card:hover .service-icon{
    transform:translateY(-6px) rotate(-8deg);
    box-shadow:
        0 25px 50px rgba(232,33,42,.35);
}`}</style>
                    {/* Right Side */}
                    <div className="why-right">

                        <div className="experience-card">

                            <div className="exp-top">
                                <span>Trusted App Development Partner</span>
                            </div>

                            <h3>
                                End-To-End Mobile App Development
                            </h3>

                            <p>
                                We transform app ideas into scalable digital products
                                with strategy, design, development and deployment —
                                all under one roof.
                            </p>

                            <div className="progress-wrapper">

                                <div className="progress-item">
                                    <div className="progress-head">
                                        <span>iOS & Android Apps</span>
                                        <span>98%</span>
                                    </div>

                                    <div className="progress-bar">
                                        <div
                                            className="progress-fill"
                                            style={{ width: "98%" }}
                                        ></div>
                                    </div>
                                </div>

                                <div className="progress-item">
                                    <div className="progress-head">
                                        <span>React Native & Flutter</span>
                                        <span>95%</span>
                                    </div>

                                    <div className="progress-bar">
                                        <div
                                            className="progress-fill"
                                            style={{ width: "95%" }}
                                        ></div>
                                    </div>
                                </div>

                                <div className="progress-item">
                                    <div className="progress-head">
                                        <span>App Store Success Rate</span>
                                        <span>100%</span>
                                    </div>

                                    <div className="progress-bar">
                                        <div
                                            className="progress-fill"
                                            style={{ width: "100%" }}
                                        ></div>
                                    </div>
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
            </section>
            {/* ===== APP SERVICES SECTION ===== */}

            <section
                className="services-section"
                style={{
                    padding: "110px 24px",
                    background:
                        "linear-gradient(170deg,#fff 0%,#fff7f7 40%,#fff 100%)",
                    position: "relative",
                    overflow: "hidden",
                }}
            >

                {/* Background Glow */}
                <div
                    style={{
                        position: "absolute",
                        top: "-120px",
                        left: "-120px",
                        width: "320px",
                        height: "320px",
                        borderRadius: "50%",
                        background: "rgba(232,33,42,.05)",
                        filter: "blur(40px)",
                    }}
                ></div>

                <div className="services-container">

                    {/* Heading */}
                    <div className="services-heading">


                        <span className="process-badge">
                            Services
                        </span>
                        <h2 style={{ textAlign: "center", }}>
                            Everything You Need To<br />
                            <span> Build & Scale Apps.</span>
                        </h2>

                        <p style={{ textAlign: "center", }}>
                            We provide complete mobile app development solutions
                            from strategy and design to deployment and scaling.
                        </p>

                    </div>

                    {/* Cards */}
                    <div className="services-grid">

                        <div className="service-card">
                            <div className="service-top">
                                <div className="service-icon">
                                    <FaApple />
                                </div>
                                <span>01</span>
                            </div>

                            <h3>iOS App Development</h3>

                            <p>
                                High-performance iPhone & iPad applications
                                built with Swift for seamless Apple ecosystem integration.
                            </p>
                        </div>

                        <div className="service-card">
                            <div className="service-top">
                                <div className="service-icon">
                                    <FaAndroid />
                                </div>
                                <span>02</span>
                            </div>

                            <h3>Android App Development</h3>

                            <p>
                                Scalable Android apps developed using Kotlin
                                with smooth UI and optimized performance.
                            </p>
                        </div>

                        <div className="service-card">
                            <div className="service-top">
                                <div className="service-icon">
                                    <TbBrandReactNative />
                                </div>
                                <span>03</span>
                            </div>

                            <h3>React Native Apps</h3>

                            <p>
                                Cross-platform mobile apps with native-like
                                performance and faster development cycles.
                            </p>
                        </div>

                        <div className="service-card">
                            <div className="service-top">
                                <div className="service-icon">
                                    <SiFlutter />
                                </div>
                                <span>04</span>
                            </div>

                            <h3>Flutter App Development</h3>

                            <p>
                                Beautiful multi-platform apps with a single codebase
                                powered by Flutter framework.
                            </p>
                        </div>

                        <div className="service-card">
                            <div className="service-top">
                                <div className="service-icon">
                                    <FaPaintBrush />
                                </div>
                                <span>05</span>
                            </div>

                            <h3>UI/UX For Mobile Apps</h3>

                            <p>
                                Modern app interfaces crafted for better engagement,
                                usability and retention.
                            </p>
                        </div>

                        <div className="service-card">
                            <div className="service-top">
                                <div className="service-icon">
                                    <FaRocket />
                                </div>
                                <span>06</span>
                            </div>

                            <h3>App Launch & Support</h3>

                            <p>
                                Deployment, App Store optimization,
                                maintenance and future scalability support.
                            </p>
                        </div>

                    </div>

                </div>

            </section>
            <ProcessSection />
            <TechnologiesSection />
            <PortfolioSection />
            <TestimonialsSection />
            <FinalCTA />
            <Footer />
        </>
    )
}

export default Home